import { buildCloudFrontUrl } from '@/utils/pathUtils';
import { uploadFileToS3 } from '@/utils/s3Utils';

const EMPTY_IMG = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('TextureService', textureService);

    function textureService($q, TextureAPIService, blockUI, $mdDialog) {
        let currentTextures = [];

        function getAllTextures() {
            return $q(function (resolve, reject) {
                TextureAPIService.getTextures()
                    .then(function (textures) {
                        currentTextures = textures;
                        resolve(textures);
                    })
                    .catch(function (e) {
                        reject(e);
                    });
            });
        }

        function changeFontTexture(texturePath, textSelected, selectedIndex) {
            return new Promise((resolve, reject) => {
                //this represents the texture position
                if (!textSelected.textures) {
                    textSelected.textures = [];
                }
                const selectedTexture = textSelected.textures.find(
                    (textureObject) => textureObject.position === selectedIndex
                );

                if (selectedTexture) {
                    selectedTexture.texturePath = texturePath;
                } else if (texturePath?.length) {
                    textSelected.textures.push({
                        position: selectedIndex,
                        texturePath: texturePath,
                        textureScale: 100
                    });
                }

                textSelected.texture = texturePath;

                const textureImage = new Image();
                textureImage.onload = function () {
                    /**
                     * You may wonder why we are applying that crazy matrix transformation. We'll my friend, that is to match the production file
                     * texture positioning and size which is created using svg and not very based on fabric.
                     * Unfortunately the pattern export that fabric export (pattern.toSVG) has nothing to do with the one applied
                     * It was a painstaking task of manually calibrating the position and size for hours. There should be an easier solution
                     */
                    const pattern = new fabric.Pattern({ source: this });
                    textSelected.set('fill', pattern);
                    resolve();
                };

                textureImage.onerror = (_message, _source, _lineno, _colno, error) => {
                    reject(error);
                };
                textureImage.crossOrigin = 'Anonymous';

                textureImage.src = texturePath ? buildCloudFrontUrl(texturePath) : EMPTY_IMG;
            });
        }

        function checkIfAnyTextElementHasATexture(canvas, $scope) {
            $scope.atLeastOneTexturedElement = canvas.getObjects().some((o) => o.texture);
        }

        function changeScaleTexture(textSelected, selectedIndex, textureScale) {
            return new Promise((resolve) => {
                if (!textSelected.textures) {
                    textSelected.textures = [];
                }
                var elementsInPosition = textSelected.textures.filter(function (textureObject) {
                    return textureObject.position === selectedIndex;
                });
                if (elementsInPosition.length > 0) {
                    elementsInPosition[0].textureScale = textureScale || 100;
                } else {
                    textSelected.textures.push({
                        position: selectedIndex,
                        texturePath: null,
                        textureScale: textureScale || 100
                    });
                }
                textSelected.set('textureScale', textureScale);
                resolve();
            });
        }

        async function uploadTexture(file) {
            console.log('Uploading texture file: ' + file.name);
            const response = await TextureAPIService.getTexturesUploadSignedUrl(file.name);
            await uploadFileToS3(response.SignedUrl, response.Mime, file);
            console.log(`Texture ${response.Name} uploaded!`);
            return response.Name;
        }

        function deleteTexture(texturePath) {
            return new Promise((resolve, reject) => {
                var textureName = texturePath.substr(texturePath.lastIndexOf('/') + 1, texturePath.length);
                $mdDialog
                    .show(
                        $mdDialog
                            .confirm()
                            .clickOutsideToClose(false)
                            .multiple(true)
                            .title('Confirmation')
                            .htmlContent('<p>Are you sure you want to delete the texture ' + textureName + '?</p>')
                            .ok('OK')
                            .cancel('Cancel')
                    )
                    .then(async function () {
                        blockUI.start('Deleting texture');
                        await TextureAPIService.deleteTexture(textureName)
                            .then(function () {
                                blockUI.stop();
                                console.log('Deleted texture ' + textureName);
                                $mdDialog
                                    .show(
                                        $mdDialog
                                            .alert()
                                            .clickOutsideToClose(false)
                                            .multiple(true)
                                            .title('Texture deleted')
                                            .htmlContent('<p>The texture ' + textureName + ' was deleted.</p>')
                                            .ok('OK')
                                    )
                                    .then(function () {
                                        resolve(true);
                                    });
                            })
                            .catch(function (err) {
                                console.log('Error deleting texture ' + err);
                                blockUI.stop();
                                $mdDialog
                                    .show(
                                        $mdDialog
                                            .alert()
                                            .clickOutsideToClose(false)
                                            .multiple(true)
                                            .title('Error deleting texture')
                                            .htmlContent(
                                                '<p>The texture was not deleted.' + err?.data?.error
                                                    ? ' ' + err?.data?.error
                                                    : '' + '</p>'
                                            )
                                            .ok('OK')
                                    )
                                    .then(function () {
                                        resolve(true);
                                    });
                                reject(err);
                            });
                    });
            });
        }

        return {
            getAllTextures: getAllTextures,
            changeFontTexture: changeFontTexture,
            changeScaleTexture: changeScaleTexture,
            checkIfAnyTextElementHasATexture: checkIfAnyTextElementHasATexture,
            uploadTexture: uploadTexture,
            deleteTexture: deleteTexture
        };
    }
})();
